/* eslint-disable no-unreachable */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
// import dateFormat from 'dateformat';
// import { date } from 'joi';
import { GameLogData } from '../../data/GameLogData';
import { Board } from '../../data/Board';
import {
    WhiteSource,
    RedSource,
    GreenSource,
    GrayEmptyCircle,
    PlannedTaskCircle,
    Task,
    Risk,
    Gate,
    Millstone,
    ConstraintIcon,
    ConstraintLog,
    GateLog,
    MillstoneLog,
    PlannedTaskLog,
    RiskLog,
    UnplannedTaskLog,
    DelayLog,
    MiddleTurnLog,
    // DiamondLog,
    // GreenGuyLog,
    // GrayGuyLog,
    // PinkGuyLog,
} from '../../Constants/assets';

// Stylings
const ActionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 15%;
    margin-bottom: 24px;
`;
const ActionDateAndTimeContainer = styled.div`
    align-self: center;
    width: 16%;
`;
const ActionDate = styled.div`
    font-size: 12px;
    color: ${props => props.theme.colors.gray};
    npm install dateFormat
`;
const ActionTitle = styled.div`
    font-weight: 500;
    font-size: 19px;
    line-height: 22px;
    color: ${(props) => props.style?.code == 8 && props.style?.NotLanded == 1 ? '#81818c' : '#2b2b32'};

`;
const ActionDetails = styled.div`
    display: grid;
    width: 80%;
`;
const InformationContainer = styled.div`
    display: flex;
`;

const ResourcesIconsComponent = styled.div`
    width: 35%;
`;
const DetailContainer = styled.div`
//     // display: inline-flex;
//     line-height: 20px;
    display: inline-flex;
`;
const Line = styled.div`
    display: inline-flex;
    margin: -18px 0;
    align-self: center;
    background-color: ${props => props.theme.colors.gray};
    width: 1px;
`;

const LineTwo = styled.div`
    display: inline-flex;
    margin: 0 0;
    align-self: center;
    background-color: ${props => props.theme.colors.gray};
    width: 1px;
`;

const Steps = styled.div`
    display: inline-flex;
    // line-height: 20px;
`;
const MiniTitle = styled.div`
    margin-left: ${props => (props.gap ? '5%' : '3%')};
    // margin-left: ${props => (props.steps ? '0%' : '3%')};
    // width:100%;
    font-size: 12px;
    color: ${props => props.theme.colors.gray};
`;

const MiniLabel = styled.div`
    display: inline-flex;
    justify-content: space-around;
    font-size: 12px;
    // font-size: 21px;
    padding-left: 6px;
    color: ${props => props.theme.colors.gray};
`;
const Label = styled.div`
    display: flex;
    justify-content: space-around;
`;
const ActionLogo = styled.div`
    width: 50px;
    text-align: center;
`;
const LogoContainer = styled.div``;
const LogoNumber = styled.div`
    font-size: 12px;
    position: relative;
    color: ${(props) => props.milestoneStyle?.code == 8 && props.milestoneStyle?.NotLanded == 1 ? '#81818c !important' : 'white'};
`;

export default function GameLogActions({
    positionIndex,
    code,
    value,
    decision,
    budget,
    earnedValue,
    regular,
    senior,
    expensive,
    location,
    creationDateTime,
    data,
    isLast,
    tasksArray,
}) {
    const { t } = useTranslation();

    const translationCodeToAction = {
        0: t('global_variables.actions.empty'),
        1: t('global_variables.actions.empty'),
        2: t('global_variables.actions.planned_task'),
        3: t('global_variables.actions.unplanned_task'),
        4: t('global_variables.actions.risk'),
        5: t('global_variables.actions.constraint'),
        6: t('global_variables.actions.delay'),
        7: t('global_variables.actions.additional_budget'),
        8: t('global_variables.actions.milestone'),
        9: t('global_variables.actions.gate'),
        10: t('global_variables.actions.additional_resources'),
        11: t('global_variables.actions.general_pm_task'),
        12: t('global_variables.actions.empty'), // those are the comments
        13: t('global_variables.actions.revisiting_gate'), // Second Gate Test
        // 75: t('global_variables.actions.pause'),
        // 76: t('global_variables.actions.unpause'),
    };
    const unwantedCodesArray = [21];

    const buyInPause = () => {
        let result;
        const totalBuy = Math.abs(data.cost);
        const totalRegular = Math.abs(data.spentRegular);
        const totalSenior = Math.abs(data.spentSenior);
        const totalexecutive = Math.abs(data.spentExpensive);
        if (totalRegular * 100 + totalSenior * 200 + totalexecutive * 500 == totalBuy) {
            result = true;
        } else {
            result = false;
        }
        return result;
    };
    const { turnData, cardData } = data;
    const d = turnData?.creationDateTime ? Date.parse(turnData.creationDateTime) : Date.parse(turnData.creationDatetime);
    const hour = new Date(d).toString().slice(15, 21);
    const date = new Date(d).toISOString().slice(0, 10);

    const canBeMultipleLogos = (turnDataObj) => {
        if (turnDataObj && turnDataObj.type == 'planned-task') {
            return (
                <>
                    <PlannedTaskLog
                        style={{ position: 'relative', width: '40px', height: '40px' }}
                    />
                    <LogoNumber
                        style={{ color: '#005857', transform: ' translate(0%, -160%)' }}
                    >
                        {turnDataObj.spotNumber}
                    </LogoNumber>
                </>
            );
        } if (turnDataObj && turnDataObj.type == 'Risk') {
            return (
                <>
                    <RiskLog
                        style={{ position: 'relative', width: '40px', height: '40px' }}
                    />
                    <LogoNumber
                        style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                    >
                        {turnDataObj.spotNumber}
                    </LogoNumber>
                </>

            );
        } if (turnDataObj && turnDataObj.type == 'unplanned-task') {
            return (
                <>
                    <UnplannedTaskLog
                        style={{ position: 'relative', width: '40px', height: '40px' }}
                    />
                    <LogoNumber
                        style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                    >
                        {turnDataObj.spotNumber}
                    </LogoNumber>
                </>
            );
        } if (turnDataObj && turnDataObj.type == 'Constraint') {
            return (
                <>
                    <ConstraintLog
                        style={{ position: 'relative', width: '40px', height: '40px' }}
                    />
                    <LogoNumber
                        style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                    >
                        {turnDataObj.spotNumber}
                    </LogoNumber>
                </>
            );
        }
        if (turnDataObj && turnDataObj.type == 'gate') {
            return (
                <>
                    <GateLog
                        style={{ position: 'relative', width: '40px', height: '40px' }}
                    />
                    <LogoNumber
                        style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                    >
                        {turnDataObj.spotNumber}
                    </LogoNumber>
                </>
            );
        }
        if (turnDataObj && turnDataObj.type == 'mile-stone') {
            return (
                <>
                    <MillstoneLog
                        style={{ position: 'relative', width: '40px', height: '40px' }}
                    />
                    <LogoNumber
                        style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                    >
                        {turnDataObj.spotNumber}
                    </LogoNumber>
                </>
            );
        }
    }

    const logoContainerSwitch = () => {
        // console.log("(●'◡'●)", data);
        switch (turnData?.code) {
            case 11:
                if (turnData && turnData?.type == 'planned-task') {
                    return (
                        <>
                            <PlannedTaskLog
                                style={{ position: 'relative', width: '40px', height: '40px' }}
                            />
                            <LogoNumber
                                style={{ color: '#005857', transform: ' translate(0%, -160%)' }}
                            >
                                {turnData.spotNumber}
                            </LogoNumber>
                        </>
                    );
                }
                if (turnData && turnData?.type == 'mile-stone') {
                    return (
                        <>
                            <MillstoneLog
                                style={{ position: 'relative', width: '40px', height: '40px' }}
                            />
                            <LogoNumber
                                style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                            >
                                {turnData.spotNumber}
                            </LogoNumber>
                        </>
                    );
                }
                break;
            case 2:
                if (turnData.type != 'gate') {
                    return (
                        <>
                            <PlannedTaskLog
                                style={{ position: 'relative', width: '40px', height: '40px' }}
                            />
                            <LogoNumber
                                style={{ color: '#005857', transform: ' translate(0%, -160%)' }}
                            >
                                {turnData.spotNumber}
                            </LogoNumber>
                        </>
                    );
                }
                return (
                    <>
                        <GateLog
                            style={{ position: 'relative', width: '40px', height: '40px' }}
                        />
                        <LogoNumber
                            style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                        >
                            {turnData.spotNumber}
                        </LogoNumber>
                    </>
                );
            case 3:
                return (
                    <>
                        <UnplannedTaskLog
                            style={{ position: 'relative', width: '40px', height: '40px' }}
                        />
                        <LogoNumber
                            style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                        >
                            {turnData.spotNumber}
                        </LogoNumber>
                    </>
                );
            case 4:
                return (
                    <>
                        <RiskLog
                            style={{ position: 'relative', width: '40px', height: '40px' }}
                        />
                        <LogoNumber
                            style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                        >
                            {turnData.spotNumber}
                        </LogoNumber>
                    </>
                );
            case 8:
                return (
                    <>
                        <MillstoneLog
                            style={{ position: 'relative', width: '40px', height: '40px' }}
                        />
                        <LogoNumber milestoneStyle={{ code: turnData.code, NotLanded: turnData.decision }}
                            style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                        >
                            {turnData.spotNumber}
                        </LogoNumber>
                    </>
                );
            case 9:
                return (
                    <>
                        <GateLog
                            style={{ position: 'relative', width: '40px', height: '40px' }}
                        />
                        <LogoNumber
                            style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                        >
                            {turnData.spotNumber}
                        </LogoNumber>
                    </>
                );
            case 13:
                return (
                    <>
                        <GateLog
                            style={{ position: 'relative', width: '40px', height: '40px' }}
                        />
                        <LogoNumber
                            style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                        >
                            {turnData.spotNumber}
                        </LogoNumber>
                    </>
                );
            case 5:
                return (
                    <>
                        <ConstraintLog
                            style={{ position: 'relative', width: '40px', height: '40px' }}
                        />
                        <LogoNumber
                            style={{ color: 'white', transform: ' translate(0%, -160%)' }}
                        >
                            {turnData.spotNumber}
                        </LogoNumber>
                    </>
                );
            case 6:
                return canBeMultipleLogos(turnData)
            case 10:
                // if value == 1 it was on pause.
                if (turnData && turnData.value == "1") {
                    return (
                        <>
                            <MiddleTurnLog
                                style={{ position: 'relative', width: '40px', height: '40px' }}
                            />
                        </>
                    );
                } 
                return canBeMultipleLogos(turnData)
            case 7:
                // if value == 1 it was on pause.
                if (turnData && turnData.value == "1") {
                    return (
                        <>
                            <MiddleTurnLog
                                style={{ position: 'relative', width: '40px', height: '40px' }}
                            />
                        </>
                    );
                } 
                return canBeMultipleLogos(turnData)
            default:
                break;
        }
    }
    if (unwantedCodesArray.includes(turnData.code)) return null;
    return (
        <ActionContainer>
            <ActionDateAndTimeContainer>
                <ActionDate style={{ direction: 'rtl' }}>{date}</ActionDate>
                <ActionDate style={{ direction: 'rtl' }}>{hour}</ActionDate>
            </ActionDateAndTimeContainer>
            <ActionLogo>
                <LogoContainer style={{ position: 'relative' }}>
                    {logoContainerSwitch()}
                </LogoContainer>
                {(turnData.code == 2 || turnData.code == 3 || turnData.code == 4 || turnData.code == 5 || turnData.code == 6 || turnData.code == 8 || turnData.code == 9 || turnData.code == 11 || turnData.code == 13 || ((turnData.code == 7 || turnData.code == 10) && turnData.value != "1")) && (
                    <Line style={{ height: isLast ? '0' : '52.5px' }} />
                )}
                {/* {((turnData.code == 7 || turnData.code == 10) && turnData.value != "1") && (
                    <LineTwo style={{ height: isLast ? '0' : '95px' }} />
                )} */}
                {((turnData.code == 7 || turnData.code == 10) && turnData.value == "1") && (
                    <LineTwo style={{ height: isLast ? '0' : '52.5px' }} />
                )}
            </ActionLogo>
            <ActionDetails>
                {(turnData.code != 10 && turnData.code != 7 && turnData.code != 2) && (
                    <ActionTitle style={{ code: turnData.code, NotLanded: turnData.decision }}>
                        {translationCodeToAction[turnData.code]} # {turnData.value}
                    </ActionTitle>
                )}
                {(turnData.code == 2) && (
                    <ActionTitle>
                        {translationCodeToAction[turnData.code]} # {turnData.value}
                    </ActionTitle>
                )}
                {turnData.code == 10 && (
                    <ActionTitle>
                        {translationCodeToAction[turnData.code]}
                    </ActionTitle>
                )}
                {turnData.code == 7 && (
                    <ActionTitle>
                        {translationCodeToAction[turnData.code]}
                    </ActionTitle>
                )}
                <InformationContainer>
                    <DetailContainer>
                        {turnData.code != 7 && cardData.costMoney <= 0 && (
                            <MiniTitle>{t('global_variables.cost')}:</MiniTitle>//
                        )}
                        {(turnData.code == 7 || cardData.costMoney > 0) && (
                            <MiniTitle>{t('global_variables.budget')}:</MiniTitle>
                        )}
                        <MiniLabel> ${Math.abs(cardData.costMoney)}</MiniLabel>
                    </DetailContainer>
                    <MiniTitle> | </MiniTitle>
                    <DetailContainer>
                        {' '}
                        <MiniTitle>{t('global_variables.resources.resources')}: </MiniTitle>
                        <MiniLabel>
                            {/* <MiniLabel> {Math.abs(data.spentRegular)}</MiniLabel>
                            <MiniTitle>Senior:</MiniTitle>
                            <MiniLabel> {Math.abs(data.spentSenior)}</MiniLabel>
                            <MiniTitle>Executive:</MiniTitle>
                            <MiniLabel> {Math.abs(data.spentExpensive)}</MiniLabel> */}
                            <MiniTitle>{t('global_variables.resources.standard')}:</MiniTitle>
                            <MiniLabel> {cardData.costResourcesNormal}</MiniLabel>
                            <MiniTitle>{t('global_variables.resources.senior')}:</MiniTitle>
                            <MiniLabel> {cardData.costResourcesSenior}</MiniLabel>
                            <MiniTitle>{t('global_variables.resources.executive')}:</MiniTitle>
                            <MiniLabel> {cardData.costResourcesExpensive}</MiniLabel>
                        </MiniLabel>
                    </DetailContainer>
                    {(turnData.code != 7 && turnData.code != 10) && (
                        <MiniTitle gap> | &nbsp; </MiniTitle>
                    )}
                    <DetailContainer>
                        {(turnData.code != 7 && turnData.code != 10) && (
                            <>
                                <MiniTitle>{t('global_variables.value')}:</MiniTitle>
                                <MiniLabel> {cardData.earnedValue ? cardData.earnedValue : 0}</MiniLabel>
                            </>
                        )}
                    </DetailContainer>
                    {(turnData.code != 7 && turnData.code != 10) && (
                        <>
                            <MiniTitle> | </MiniTitle>
                            <br />
                        </>
                    )}
                </InformationContainer>
                {(turnData.code != 7 && turnData.code != 10) && (
                    <>
                        <Steps>
                            {' '}
                            <MiniTitle steps style={{ marginLeft: '0%' }}>
                            {t('global_variables.steps')}:
                            </MiniTitle>
                            {/* {(turnData.code == 8 || turnData.code == 11) && (
                                <MiniLabel>0</MiniLabel>

                            )} */}
                            <MiniLabel>{cardData.steps}</MiniLabel>
                        </Steps>
                    </>
                )}
            </ActionDetails>
        </ActionContainer>
    );
}
